{
  "title": "Hand of Radiance (UA)",
  "source": "Unearthed Arcana 36 - Starter Spells",
  "levelAndSchool": "Evocation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "5 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You raise your hand, and burning radiance erupts from it. Each creature of your choice that you can see within 5 feet of you must succeed on a Constitution saving throw or take 1d6 radiant damage.",
    "At Higher Levels: The spell's damage increases by 1d6 when you reach 5th level (2d6), 11th level (3d6), and 17th level (4d6).",
    "Spell Lists: Cleric"
  ],
  "spellLists": ["cleric"]
}
